module.exports = __webpack_public_path__ + "static/media/employeeEmpty.a2018a9a.svg";